import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LOGIN_OTP_SEND,
  LOGIN_OTP_SEND_SUCCESS,
  LOGIN_OTP_SEND_FAIL,
  LOGIN_OTP_VERIFY,
  LOGIN_OTP_VERIFY_SUCCESS,
  LOGIN_OTP_VERIFY_FAIL,
} from './login-otp.actions';
import { mergeMap, catchError, of, tap } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { ADD_MESSAGE } from '../messages/messages.actions';

@Injectable()
export class LoginOtpEffects {
  sendOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOGIN_OTP_SEND),
      mergeMap(({ telefono }) =>
        this.api.loginOtpGenera(telefono).pipe(
          mergeMap((response: any) => [
            LOGIN_OTP_SEND_SUCCESS({
              esito: response.esito,
              seed: response.seed!,
              otpTtlSeconds: response.otpTtlSeconds,
              maxTentativi: response.maxTentativi,
              telefono,
              msgCode: response.msgCode
            }),
          ]),
          catchError((error) => {
            this.store.dispatch(
              ADD_MESSAGE({
                message: error?.message ?? 'Errore invio OTP',
              })
            );
            return of(LOGIN_OTP_SEND_FAIL({ error }));
          })
        )
      )
    )
  );

  verifyOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOGIN_OTP_VERIFY),
      mergeMap(({ otp, seed, username }) =>
        this.api.loginOtpVerifica({ otp, seed, username }).pipe(
          mergeMap((response: any) => {
            // Allinea il flusso OTP al login standard: rende disponibili username/mail per validazione cambio password
            const resolvedUsername = response?.username || username || '';
            const resolvedMail = response?.mail || '';

            if (resolvedUsername) {
              sessionStorage.setItem('usernameCambioPassword', resolvedUsername);
            }
            if (resolvedMail) {
              sessionStorage.setItem('mailCambioPassword', resolvedMail);
            }

            return [
              LOGIN_OTP_VERIFY_SUCCESS({
                esito: response.esito,
                msgCode: response.msgCode,
                username: resolvedUsername,
              }),
            ];
          }),
          catchError((error) => {
            this.store.dispatch(
              ADD_MESSAGE({
                message: error?.message ?? 'Errore verifica OTP',
              })
            );
            return of(LOGIN_OTP_VERIFY_FAIL({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private store: Store
  ) {}
}